import React, {Component} from "react";
import {Alert} from "react-bootstrap";
import {withNamespaces} from "react-i18next";

class LoginForm extends Component {
    state = {
        email: null,
        password: null,
        remember: false,
    };

    handleOnChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    };

    handleOnChangeCheckbox = (e) => {
        this.setState({
            [e.target.id]: e.target.checked
        });
    };

    handleOnSubmit = (e) => {
        e.preventDefault();
        this.props.onLogin({
            email: this.state.email,
            password: this.state.password,
            remember: this.state.remember
        });
    };

    render() {
        const { t } = this.props;
        return(
            <div className='login-form mt-5'>
                <div className="row justify-content-center">
                    <div className="col-md-8">

                        <div className="alert">
                            <div id="validate" className="alert"> </div>
                        </div>

                        <div className="card">
                            <div className="card-header">{t('login')}</div>
                            <div className="card-body">
                                { !this.props.validationError || (
                                    <Alert variant={"danger"}>
                                        {t('valid.login-error')}
                                    </Alert>
                                ) }
                                <form id="loginForm" onSubmit={this.handleOnSubmit}>
                                    <div className="form-group row">
                                        <label htmlFor="email" className="col-md-4 col-form-label text-md-right">{t('email-or-username')}</label>
                                        <div className="col-md-6">
                                            <input type="text" id="email" className="form-control" onChange={this.handleOnChange} required />
                                        </div>
                                    </div>

                                    <div className="form-group row">
                                        <label htmlFor="password" className="col-md-4 col-form-label text-md-right">{t('password')}</label>
                                        <div className="col-md-6">
                                            <input type="password" id="password" className="form-control" onChange={this.handleOnChange} required/>
                                        </div>
                                    </div>


                                    <div className="form-group row">
                                        <div className="col-md-6 offset-md-4">
                                            <div className="checkbox">
                                                <input type="checkbox" id="remember" value="true" onChange={this.handleOnChangeCheckbox} /> &nbsp;
                                                <label> {t('remember-me')} </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-6 offset-md-4">
                                        <button type="submit" className="btn btn-primary">
                                            <i className="fas fa-sign-in-alt"> </i> &nbsp;
                                            { t('login') }
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withNamespaces()(LoginForm);
